import { validate as uuidValidate } from 'uuid';



export const millisecondsToUTC = (milliseconds: number) => {
    const millis = milliseconds*1000
    const date = new Date(millis);
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    const year = utcDate.getUTCFullYear();
    const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utcDate.getUTCDate()).padStart(2, '0');
    const hours = String(utcDate.getUTCHours()).padStart(2, '0');
    const minutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utcDate.getUTCSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
}

export const nostToOst = (nost: string | number) => {
    if(typeof nost === "string") nost = Number(nost)
    let converted: number = nost / 10**9;
    return converted;
}


export function isUUIDv4(s: string): boolean {
    const uuidPattern = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-4[a-fA-F0-9]{3}-[89aAbB][a-fA-F0-9]{3}-[a-fA-F0-9]{12}$/;
    return uuidPattern.test(s) && uuidValidate(s);
}

export function isNumericString(s: string, isZeroFirstAllowed = false): boolean {
    // Check if the string is empty or null
    if (!s) {
      return false;
    }
  
    // Check if the first character is a zero
    if (!isZeroFirstAllowed && s.charAt(0) === '0') {
      return false;
    }
  
    // Check if each character is a digit
    for (let i = 0; i < s.length; i++) {
      if (isNaN(parseInt(s.charAt(i), 10))) {
        return false;
      }
    }
  
    return true;
}

export function isHex64(str: string): boolean {
    // Check if string is exactly 64 characters long
    if (str.length !== 64) {
      return false;
    }
  
    // Check if string is a valid hexadecimal string
    const isHex = /^[0-9a-fA-F]+$/.test(str);
    return isHex;
}

export const isOmnistarAddress = (input: string) => {
  const regex = /^[a-z0-9]*$/;
  return input.startsWith("omnistar1") && input.length > 40 && regex.test(input.slice(8));
}


// bitcoin - https://live.blockcypher.com/btc/address/1FWQiwK27EnGXb6BiBMRLJvunJQZZPMcGd/
// bitcoin testnet - https://live.blockcypher.com/btc-testnet/address/tb1qj0rte6mvft3ugjyg3p2uvsrgzx9jr4dqms25lp

// ethereum, avax - https://etherscan.io/tx/0xd0848e69ef31b06752b454789ac2826be47da2f89db69e913caf23e2085b86c5
// ethereum, avax testnet - https://goerli.etherscan.io/address/0x86Ae56E883182255FB32D3703C4F677E54b059B1

// doge - https://blockexplorer.one/dogecoin/mainnet/address/DKDY3giKMNrkKnFTArotpLZTJQ2DVErWUt
// doge testnet - https://blockexplorer.one/dogecoin/testnet/address/nhfXg2UmnhnmJJ6FBmw4yc5rJefjnRNzuq

// solana - https://explorer.solana.com/address/uo2oMaSHzWn9vEnXV7fqwSfXcy1Fadv3KFJYLVS2cfn
// solana testnet - https://explorer.solana.com/address/4oNLVyXCtAYYXny4B5bph1BJLQAmh1kyVENgb2dBZP3K?cluster=testnet

// cardano - https://cardanoscan.io/address/addr1vyw94p7907wfp8lqrl45lu0wj8jwp82s2zys9w3ckdzxnvqdd9ady
// cardano testnet - https://preprod.cardanoscan.io/address/6013ba0c38b635971740f09f028e30d6c4b60098a65ed1d5efe9794e58

// xrp - https://xrpscan.com/account/rMZfqwKNV3Lq2kh2YxLxyKcHpede5mDMnf
// xrp testnet - 


export const getExplorerLink = (symbol: string, address: string, isMain: boolean) => {
  let link: string = "";

  switch (symbol.toLowerCase()) {
    case "ost":
      link = `https://explorer.omnistar.io/snapshots/${address}?lab=${isMain? "mainnet" : "testnet"}`
      break;
    case "btc":
      link = isMain
        ? `https://live.blockcypher.com/btc/address/${address}/`
        : `https://live.blockcypher.com/btc-testnet/address/${address}`
      break;
    case "doge":
      link = isMain
        ? `https://blockchair.com/dogecoin/address/${address}`
        : `https://blockexplorer.one/dogecoin/testnet/address/${address}`
      break;
    case "eth":
    case "avax":
      link = isMain
        ? `https://etherscan.io/address/${address}`
        : `https://goerli.etherscan.io/address/${address}`
      break;
    case "sol":
      link = isMain
        ? `https://explorer.solana.com/address/${address}`
        : `https://explorer.solana.com/address/${address}?cluster=testnet`
        
      break;
    case "ada":
      link = isMain
        ? `https://cardanoscan.io/address/${address}`
        : `https://preprod.cardanoscan.io/address/${address}`
      break;
    case "xrp":
      link = isMain
        ? `https://xrpscan.com/account/${address}`
        : ""
      break;
  
    default:
      link = "";
      break;
  }

  return link
}
  